import React from 'react';

const R = 36;
const CX = 50;
const CY = 50;

/**
 * Full ring; stroke color from tier (liked / disliked / neutral). Score shown in center.
 */
export default function ScoreMeter({ score, kind, compact = false }) {
  const n = Number(score);
  const safe = Number.isFinite(n) ? Math.max(1, Math.min(10, n)) : 1;
  const stroke =
    kind === 'liked' ? '#16a34a' : kind === 'disliked' ? '#ca8a04' : '#6b7280';

  return (
    <div
      className={`flique-score-meter${compact ? ' flique-score-meter--compact' : ''}`}
      title={`${safe.toFixed(1)} / 10`}
      aria-label={`Score ${safe.toFixed(1)} out of 10`}
    >
      <div className="flique-score-meter-wrap">
        <svg
          className="flique-score-meter-svg"
          viewBox="0 0 100 100"
          aria-hidden="true"
        >
          <circle
            cx={CX}
            cy={CY}
            r={R}
            fill="none"
            stroke={stroke}
            strokeWidth="10"
            strokeLinecap="round"
            transform={`rotate(-90 ${CX} ${CY})`}
          />
        </svg>
        <span className="flique-score-meter-value" style={{ color: stroke }}>
          {safe.toFixed(1)}
        </span>
      </div>
    </div>
  );
}
